Object.defineProperty(exports,"__esModule",{value:true});exports.default=






mapResourceUpdate;var _MQTTActions=require('../actions/MQTTActions');var actions=_interopRequireWildcard(_MQTTActions);var _resource_updated_pb=require('../protoModels/mti/resource_updated_pb');function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function mapResourceUpdate(message){
switch(message.getContext()){
case _resource_updated_pb.ResourceUpdated.Context.STORE:
return actions.updateStore(message.getContextId(),message.getAction());
case _resource_updated_pb.ResourceUpdated.Context.STORE_RULE:
return actions.updateStoreRule(
message.getContextId(),
message.getStoreId(),
message.getAction());

case _resource_updated_pb.ResourceUpdated.Context.SECURITY_DEVICE:
return actions.updateSecurityDevice(
message.getContextId(),
message.getStoreId(),
message.getAction());

case _resource_updated_pb.ResourceUpdated.Context.FIXTURE:
return actions.updateFixture(
message.getContextId(),
message.getStoreId(),
message.getAction());

case _resource_updated_pb.ResourceUpdated.Context.FIXTURE_RULE:
return actions.updateFixtureRule(
message.getContextId(),
message.getStoreId(),
message.getAction());

case _resource_updated_pb.ResourceUpdated.Context.POSITION:
return actions.updatePosition(
message.getContextId(),
message.getStoreId(),
message.getAction());

case _resource_updated_pb.ResourceUpdated.Context.POSITION_RULE:
return actions.updatePositionRule(
message.getContextId(),
message.getStoreId(),
message.getAction());

case _resource_updated_pb.ResourceUpdated.Context.RULE:
return actions.updateRule(
message.getContextId(),
message.getStoreId(),
message.getAction());

case _resource_updated_pb.ResourceUpdated.Context.PRODUCT:
return actions.updateProduct(
message.getContextId(),
message.getStoreId(),
message.getAction());

case _resource_updated_pb.ResourceUpdated.Context.SECURED_PRODUCT:
return actions.updateSecuredProduct(
message.getContextId(),
message.getStoreId(),
message.getAction());

default:
console.warn('Unrecognized resource update message',messagae);}

}